import { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  Navbar,
  Container,
  NavDropdown,
  Nav,
  Breadcrumb,
} from "react-bootstrap";
import Sidebar from "../Components/Sidebar/Sidebar";
import SearchModal from "../Components/SearchModal/SearchModal";
import LanguageSelector from "../Components/LanguageSelector"; // Importer le Language Selector
import { useAuth } from "../Context/AuthContext";
import "../Components/BreadCrumb.css";
import { useHttpClient } from "../hooks/http-hook";
import "./RootLayout.css";
import { useTranslation } from "react-i18next"; // Importer useTranslation

export default function RootLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuth, authData } = useAuth();
  const { sendRequest } = useHttpClient();
  const [showSearch, setShowSearch] = useState(false);
  const excludedPathsForBreadcrumb = ["/module-structure", "/users", "/"]; // Ajouter "/" ici
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  const handleLogout = async () => {
    try {
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}auth/logout`,
        "POST",
        null,
        {
          "Content-Type": "application/json",
        }
      );

      console.log("Logout response:", response);

      if (response.message === "Logged out successfully") {
        setAuth(null, null, false);
        console.log("Auth state updated.");
        navigate("/login");
      } else {
        throw new Error("Erreur de déconnexion");
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const pathnames = location.pathname.split("/").filter((x) => x);
  console.log("PATH TAB : " + pathnames);

  return (
    <div className="root-layout d-flex flex-column">
      <header>
        <Navbar
          expand="lg"
          className="bg-white bg-gradient shadow-sm mb-1 py-3"
        >
          <Container fluid>
            <Navbar.Brand
              onClick={() => navigate("/")}
              className="text-primary fw-bold fs-5 text-uppercase"
            >
              <i className="bi bi-mortarboard-fill me-1"></i>
              ProfD
            </Navbar.Brand>

            <Nav className="ms-auto d-flex align-items-center">
              {/* Language Selector */}
              <LanguageSelector />

              {authData.isLoggedIn && (
                <Nav.Link onClick={() => setShowSearch(true)}>
                  <i className="bi bi-search text-black fs-5"></i>
                </Nav.Link>
              )}

              {/* User Dropdown */}
              <NavDropdown
                title={<i className="bi bi-person-fill text-black"></i>}
                id="navbarScrollingDropdown"
                className="ms-3 me-3 text-black bg-gradient rounded fs-4"
                align="end"
              >
                <NavDropdown.Item onClick={() => navigate("/profile")}>
                  {t("profile")}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                {authData.isLoggedIn ? (
                  <NavDropdown.Item onClick={handleLogout}>
                    {t("logout")}
                  </NavDropdown.Item>
                ) : (
                  <NavDropdown.Item onClick={() => navigate("/login")}>
                    {t("login")}
                  </NavDropdown.Item>
                )}
              </NavDropdown>
            </Nav>
          </Container>
        </Navbar>
      </header>

      <div className="d-flex flex-grow-1 content">
        {authData.isLoggedIn && <Sidebar />}

        <main className="flex-grow-1 p-3">
          {/* Fil d'Ariane dynamique */}
          {!excludedPathsForBreadcrumb.some(
            (path) => location.pathname === path
          ) && (
            <Breadcrumb className="custom-breadcrumb">
              <Breadcrumb.Item onClick={() => navigate("/")}>
                {t("home")}
              </Breadcrumb.Item>
              {pathnames.map((value, index) => {
                const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                return (
                  <Breadcrumb.Item
                    key={to}
                    onClick={() => navigate(to)}
                    active={index === pathnames.length - 1}
                  >
                    {t(value)}
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
          )}
          <Outlet />
        </main>
      </div>

      <SearchModal show={showSearch} handleClose={() => setShowSearch(false)} />
    </div>
  );
}
